<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="leftLine"></span>
      <el-breadcrumb-item>客户电量申报管理</el-breadcrumb-item>
      <el-breadcrumb-item>查看申报</el-breadcrumb-item>
      <el-breadcrumb-item>编辑</el-breadcrumb-item>
      <el-button type="primay"
                 style="float:right;margin:6px 60px"
                 @click="$router.back()">返回</el-button>
    </el-breadcrumb>
    <div style="padding:20px;background:rgb(249,249,249)">
      <div class="containerBox">
        <p class="header">编辑</p>
        <div class="form">
          <el-form ref="form"
                   :model="form"
                   label-width="140px">
            <el-form-item label="账号">
              <el-input v-model="form.userAccount"></el-input>
            </el-form-item>
            <el-form-item label="用电日期"
                          required>
              <el-date-picker v-model="form.electrotimeStart"
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="企业订单情况">
              <el-select v-model="form.lastmonth"
                         placeholder="请选择">
                <el-option label="增加 15%以上"
                           :value="1"></el-option>
                <el-option label="增加 5% - 15%"
                           :value="2"></el-option>
                <el-option label="持平"
                           :value="3"></el-option>
                <el-option label=" D. 减少 15%以上"
                           :value="4"></el-option>
                <el-option label="减少 5% - 15%"
                           :value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申报电量(kW·h)"
                          required>
              <el-input v-model="form.electro" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="当月生产天数"
                          required>
              <el-input v-model="form.days" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="跟去年相同月同比"
                          required>
              <el-input v-model="form.lastyear"></el-input>
            </el-form-item>
            <el-form-item label="申报状态">
              <el-select v-model="form.status"
                         placeholder="请选择">
                <el-option label="已申报"
                           :value="1"></el-option>
                <el-option label="申报中"
                           :value="2"></el-option>
                <el-option label="未开始"
                           :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="企业补充说明">
              <el-input type="textarea"
                        v-model="form.explainNote"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="$router.back()">取消</el-button>
              <el-button @click="submitForm('form')">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getdeclareOne, getsettleAgent, postdeclare, putdeclare } from '../../API'
export default {
  data () {
    return {
      activeIndex: this.$route.path,
      form: {
        clientId: '',
        clientName: "",
        days: '',
        declareId: '',
        declaretime: "",
        electro: '',
        electrotimeEnd: "",
        electrotimeStart: "",
        explainNote: "",
        lastmonth: '',
        lastyear: '',
        status: '',
        userAccount: "",
        userId: '',
        userName: "",
      }
    }
  },
  created () {
    if (localStorage.getItem('declareId') !== null) {
      getdeclareOne(localStorage.getItem('declareId')).then(res => {
        if (res.code === 0) {
          this.form = res.data
        }
      })
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('declareId')) {
            this.form.clientId = localStorage.getItem('id')
            this.form.clientName=localStorage.getItem('clientName')
            putdeclare(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                       this.$router.back()
              }
            })

          }
          else {
            let params = this.form
                        this.form.clientName=localStorage.getItem('clientName')
            postdeclare(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.$router.back()
              }
            }).catch(err => {
              console.log(err)
            })
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  background: rgb(243, 243, 243);
  padding: 0 20px;
  border: 1px solid rgba(228, 228, 228, 1);
}
.title {
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  color: #3498db;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.form {
  background-color: #fff;
  border: 1px solid rgba(228, 228, 228, 1);
  padding: 20px;
}
.el-form {
  width: 400px;
  margin: auto;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>